import { ICreateDiarioObraImagensUseCase } from "../../../presentation/useCases/create/create_diario_obra_imagens_use_case";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";

// CreateDiarioObraImagensUseCase


export class CreateDiarioObraImagensUseCase implements ICreateDiarioObraImagensUseCase {
  constructor(private readonly repository: IDiarioObraRepository) { }

  async createDiarioObraImagens(IdDiarioObras: number | null, DescricaoImagem: string | null, Imagem: File | null, ExtensaoImagem: string | null, Nome: string | null, Ordem: number | null): Promise<void> {

    await this.repository.createDiarioObraImagens(
      IdDiarioObras, DescricaoImagem, Imagem, ExtensaoImagem, Nome, Ordem
    );
  }
}
